import { buildCardImageData } from "../buildCardImageUrl";

const SCHEME_CHOICE_OPTION_VALUES = {
  mastercard: {
    schemeName: "Mastercard",
    label: "Mastercard",
    value: "mastercard",
  },
  visa: {
    schemeName: "Visa",
    label: "Visa",
    value: "visa",
  },
  cartes_bancaires: {
    schemeName: "Cartes Bancaires",
    label: "Cartes Bancaires",
    value: "cartes_bancaires",
  },
};

const createSchemeImage = (baseImageUrl, schemeName) => {
  const { src, alt } = buildCardImageData(baseImageUrl, schemeName);
  return `<img class="scheme-choice--option-image" src="${src}" alt="${alt}"/>`;
};

const createSchemeChoiceElement = (baseImageUrl, label, schemeName) => {
  const schemeImage = createSchemeImage(baseImageUrl, schemeName);
  return `<div class="scheme-choice--option">${schemeImage}<span class="scheme-choice--option-text">${label}</span></div>`;
};

export const getSchemeChoiceOption = (option, baseImageUrl) => {
  const configuration = SCHEME_CHOICE_OPTION_VALUES[option];

  if (!configuration) {
    return;
  }

  const { schemeName, label, value } = configuration;

  return {
    label: createSchemeChoiceElement(baseImageUrl, label, schemeName),
    value,
  };
};

export const getSchemeChoiceOptionSchemeName = (schemeChoiceOption) => {
  const matchingOption = SCHEME_CHOICE_OPTION_VALUES[schemeChoiceOption];
  return matchingOption ? matchingOption.schemeName : undefined;
};

const createCheckIcon = () => {
  return `<span class="check-icon--container"><svg class="check-icon" width="8" height="8" fill="none" viewBox="0 0 8 8"  xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0H8V8H2C0.895431 8 0 7.10457 0 6V0Z" fill="currentColor"/>
    <path d="M6.0625 2.6875L3.4375 5.3125L2.125 4" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
    </svg></span>`;
};

const createRadioInput = (scheme) => {
  return `<input type="radio" name="scheme-choice" value="${scheme}" id="${scheme}" />`;
};

const createLabelBuilder = (scheme) => ({ child }) => {
  return `<label class="scheme-choice--radio-label" for="${scheme}">${child}</label>`;
};

export const createSchemeChoiceRadioButton = (scheme, imageUrl) => {
  const schemeChoiceName = getSchemeChoiceOptionSchemeName(scheme);
  const schemeImg = createSchemeImage(imageUrl, schemeChoiceName);
  const radioInput = createRadioInput(scheme);
  const labelBuilder = createLabelBuilder(scheme);

  const labelWithScheme = labelBuilder({
    child: createCheckIcon() + schemeImg,
  });

  return radioInput + labelWithScheme;
};
